let testimonialsSlider;
const initTestimonialsSlider = () => {
  const config = {
    slidesPerView: 1.1,
    spaceBetween: 12,
    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 20
      }
    },
  }
  testimonialsSlider = new Swiper('.testimonials-slider', {
    ...config,
    navigation: {
      prevEl: ".testimonials-slider__button.prev",
      nextEl: ".testimonials-slider__button.next"
    },
    pagination: {
      el: ".testimonials-slider__pagination:not(.mobile)",
      type: "bullets",
      clickable: true
    }
  });

  const customPagination = new Swiper(".testimonials-slider", {
    ...config,
    pagination: {
      el: ".testimonials-slider__pagination.mobile",
      type: "bullets",
      clickable: true
    },
  });

  testimonialsSlider.controller.control = customPagination;
}

window.addEventListener('load', initTestimonialsSlider);